import { incYenOf } from '../../../lib/pricing';
const courses = {
  // page.tsx JSON-LD
  'courses.jsonld.orgName': 'Japan Butler Academy',
  'courses.jsonld.parentOrgName': 'All Japan Butler Association',
  'courses.jsonld.addressLocality': 'Aomi 2-7-4, Koto-ku, Tokyo',
  'courses.backToTop': 'Back to top',
  'courses.lastUpdated': 'Last updated: 1 May 2026',

  // HeroSection
  'courses.hero.homeLink': 'Home',
  'courses.hero.currentPage': 'Courses',
  'courses.hero.title': 'Course Overview & Comparison',
  'courses.hero.titleEn': 'COURSES',
  'courses.hero.lead': 'The Japan Butler Academy offers three distinct courses, each designed to match your level and professional goals. \n\nFrom an introduction for beginners aspiring to become a butler, through skill development for those already working, to preparation for standing on your own as a professional, our courses form a single, staged path of butler training. \n\nCompare each course by duration, fee, and content, and choose the one closest to your own goals.',
  'courses.hero.imgAlt': 'A scene representing the three progressive levels of butler education',

  // CourseCards
  'courses.cards.label': 'THREE COURSES',
  'courses.cards.title': 'Three Courses',
  'courses.cards.subtitleEn': 'Choose Your Path',
  'courses.cards.lead': 'We offer three courses tailored to every stage of learning — whether you wish to build a solid foundation, sharpen your specialist skills, or qualify as a fully independent professional. \n\nEach course is designed to reach your goal by the most direct route.',
  'courses.cards.recommended': 'Recommended',
  'courses.cards.durationLabel': 'Duration',
  'courses.cards.daysLabel': 'Days',
  'courses.cards.hoursLabel': 'Hours',
  'courses.cards.priceLabel': 'Tuition',
  'courses.cards.priceTax': '(tax incl.)',
  'courses.cards.targetLabel': 'For',
  'courses.cards.goalLabel': 'What you gain',
  'courses.cards.certLabel': 'Certification',
  'courses.cards.viewDetail': 'Learn more',

  // CourseCards card content (index-based)
  'courses.cards.0.name': 'Essential Course',
  'courses.cards.0.duration': '1 month',
  'courses.cards.0.days': '8 days',
  'courses.cards.0.hours': '48 hours',
  'courses.cards.0.target': 'Beginners & career changers',
  'courses.cards.0.description': 'An introductory course focused on the fundamental deportment and service etiquette of a professional butler. From table manners to tea service — the essentials, properly drilled.',
  'courses.cards.0.certification': 'Certified Associate Butler',
  'courses.cards.1.name': 'Advanced Course',
  'courses.cards.1.duration': '2 months',
  'courses.cards.1.days': '12 days',
  'courses.cards.1.hours': '72 hours',
  'courses.cards.1.target': 'Those with a foundation; seeking specialist skills',
  'courses.cards.1.description': 'An intermediate course that includes the full content of the Essential Course, then builds toward advanced service technique — wine service, event management, and more. \n\nOpen to complete beginners; includes a special field training visit for hands-on real-world experience.',
  'courses.cards.1.certification': 'Certified Professional Butler',
  'courses.cards.1.inclusionBadge': 'Includes the full content of the Essential Course',
  'courses.cards.1.progressionShort': 'Month 1: Foundations (Essential content) → Month 2: Advanced (wine, events, international etiquette, etc.)',
  'courses.cards.2.name': 'Master Course',
  'courses.cards.2.duration': '3 months',
  'courses.cards.2.days': '16 days',
  'courses.cards.2.hours': '96 hours',
  'courses.cards.2.target': 'Aspiring professionals & those pursuing management roles',
  'courses.cards.2.description': 'The most advanced programme — including the full content of both the Essential and Advanced courses, then covering management, crisis response, and international protocol in full. \n\nOpen to complete beginners; culminates in a graduation dinner practical examination.',
  'courses.cards.2.certification': 'Certified Master Butler',
  'courses.cards.2.inclusionBadge': 'Includes the full content of Essential and Advanced',
  'courses.cards.2.progressionShort': 'Month 1: Essential → Month 2: Advanced → Month 3: Master specialisation (management, crisis response, etc.)',

  // CourseSelector items (index-based)
  'courses.selector.0.title': 'New to butler training? Start with Essential',
  'courses.selector.0.description': 'Ideal for those who wish to learn butler fundamentals from scratch or are making a career change into the service industry. Skills are built up methodically from first principles.',
  'courses.selector.1.title': 'Have experience? Step up to Advanced',
  'courses.selector.1.description': 'Includes the full content of the Essential Course, so complete beginners can enrol directly. Also suited to those with a hospitality or service background, or Essential graduates who wish to specialise further. \n\nDevelop advanced skills in wine service and event management.',
  'courses.selector.2.title': 'Aiming for a career or management role? Choose Master',
  'courses.selector.2.description': 'Includes the full content of both the Essential and Advanced courses, so complete beginners can enrol directly. Suited to those aspiring to work or become independent as a butler, or to reach a management role in a hotel or private residence. \n\nCovers the full professional spectrum — from household management to crisis response.',

  // ComparisonTable
  'courses.comparison.label': 'COMPARISON',
  'courses.comparison.title': 'Which Course Is Right for You?',
  'courses.comparison.subtitleEn': 'Compare All Courses',
  'courses.comparison.lead': 'Compare all three courses side by side — duration, tuition, learning objectives, and curriculum — to find the course that aligns most closely with your goals.',
  'courses.comparison.colEssential': 'Essential',
  'courses.comparison.colAdvanced': 'Advanced',
  'courses.comparison.colMaster': 'Master',
  'courses.comparison.note': '* These certifications are privately awarded by The All Japan Butler Association.',
  'courses.comparison.inclusionNote': 'The Advanced Course includes the full content of Essential; the Master Course includes the full content of both Essential and Advanced. Each course is complete on its own, so you can simply choose the one course that matches your goal.',

  // CourseSelector
  'courses.selector.label': 'HOW TO CHOOSE',
  'courses.selector.title': 'How to Choose Your Course',
  'courses.selector.subtitleEn': 'Find Your Best Fit',
  'courses.selector.lead': 'If you are unsure which course suits you best, we recommend working backwards from your goal. \n\nThe right course differs depending on whether you are a beginner, an experienced professional looking to specialise, or someone aiming for a management role.',
  'courses.selector.viewDetail': 'Learn more',
  'courses.selector.consultationNote': 'Not sure which course is right for you? Our advisors are happy to help — ',
  'courses.selector.consultationLink': 'book a free consultation (online available)',
  'courses.selector.consultationSuffix': '.',

  // TransferDiscount
  'courses.transfer.title': 'Step-Up Discount',
  'courses.transfer.lead': 'Students who progress through our courses sequentially benefit from a step-up discount. Building a strong foundation before advancing allows for deeper, more sustainable learning at every stage.',
  'courses.transfer.essentialLabel': 'Essential Graduate → Advanced',
  'courses.transfer.essentialAmount': 'JPY 80,000',
  'courses.transfer.essentialSuffix': ' reduction',
  'courses.transfer.advancedLabel': 'Advanced Graduate → Master',
  'courses.transfer.advancedAmount': 'JPY 180,000',
  'courses.transfer.advancedSuffix': ' reduction',
  'courses.transfer.detailLink': 'View tuition details',

  // CommonInfo
  'courses.commonInfo.label': 'COMMON FEATURES',
  'courses.commonInfo.title': 'Features Shared by All Courses',
  'courses.commonInfo.subtitleEn': 'What All Courses Share',
  'courses.commonInfo.item1': 'All classes are held on weekends. You can continue working while you learn.',
  'courses.commonInfo.item2': 'Six hours of intensive instruction per day (four 90-minute sessions). High-density learning throughout.',
  'courses.commonInfo.item3': 'Strictly small-group classes (maximum 6 students). Instructors examine every detail of each student\'s technique.',
  'courses.commonInfo.item4': 'Tuition is payable in full by bank transfer only. Instalment payments and credit cards are not accepted.',

  // CTASection
  'courses.cta.label': 'GET STARTED',
  'courses.cta.title': 'Take the First Step',
  'courses.cta.lead': 'Requesting a brochure and booking a consultation are both free of charge. If you are unsure which course best suits your goals, our experienced advisors will be happy to guide you.',
  'courses.cta.note': '* Online consultations are also available.',
  'courses.cta.brochure': 'Request a free brochure',
  'courses.cta.consultation': 'Book a consultation',
  'courses.cta.seminar': 'Attend a taster session',
  'courses.cta.corporateNote': 'Considering this for your company or organisation?',
  'courses.cta.corporateLink': 'See our on-site corporate training',

  // FAQSection
  'courses.faq.label': 'FAQ',
  'courses.faq.title': 'Frequently Asked Questions',
  'courses.faq.subtitleEn': 'Frequently Asked Questions',
  'courses.faq.moreQuestions': 'For further enquiries, please use our contact form.',
  'courses.faq.0.question': 'Which course is right for a complete beginner?',
  'courses.faq.0.answer': 'We recommend the Essential Course (1 month, 48 hours) for those new to butler training. It builds your skills systematically from the very foundations.',
  'courses.faq.1.question': 'Can I join at the Advanced or Master level?',
  'courses.faq.1.answer': 'Yes. The Advanced Course includes the full content of Essential, and the Master Course includes the full content of both Essential and Advanced, so you may begin directly from either level with no prior experience. \n\nOur advisors are happy to guide you during a free consultation.',
  'courses.faq.2.question': 'What payment methods are accepted?',
  'courses.faq.2.answer': 'Payment is accepted by bank transfer in full only. Instalment payments and credit cards are not available.',
  'courses.faq.3.question': 'What are the differences between the three courses?',
  'courses.faq.3.answer': 'The Essential Course (1 month, 48 hours) is an introductory programme that builds the foundational form; the Advanced Course (2 months, 72 hours) includes the full content of Essential and adds higher-level service such as wine and event operations; and the Master Course (3 months, 96 hours) includes the full content of both Essential and Advanced and extends to household management, crisis response, and international protocol. Each course is complete on its own, so you can simply choose the one course that matches your goal.',
  'courses.faq.4.question': 'How many students are in each course?',
  'courses.faq.4.answer': 'A maximum of six students per course, in a small-group format. The minimum number required to run a course is three, and places are offered on a first-come, first-served basis.',
  'courses.faq.5.question': 'Can I attend while working?',
  'courses.faq.5.answer': 'All courses are held on weekends (6 hours per day, four 90-minute sessions), so those working on weekdays can attend as planned. On-demand videos are available for preparation and review, allowing in-person sessions to focus on hands-on practice.',
  'courses.faq.6.question': 'Is there a discount for progressing through the courses in stages?',
  'courses.faq.6.answer': 'Yes, a transfer discount applies. When progressing from Essential to Advanced, JPY 80,000 (tax incl.) is deducted from the Advanced fee; from Advanced to Master, JPY 180,000 (tax incl.) is deducted from the Master fee.',

  // RelatedPages
  'courses.related.label': 'LEARN MORE',
  'courses.related.title': 'Related Pages',
  'courses.related.subtitleEn': 'Explore Further',
  'courses.related.viewDetail': 'View details',
  'courses.related.0.title': 'Essential Course',
  'courses.related.0.description': 'Introductory programme — start from the foundations',
  'courses.related.1.title': 'Advanced Course',
  'courses.related.1.description': 'Intermediate programme — develop specialist skills',
  'courses.related.2.title': 'Master Course',
  'courses.related.2.description': 'Advanced programme — management and crisis response',
  'courses.related.3.title': 'Annual Schedule',
  'courses.related.3.description': 'Intake dates and class timetable',
  'courses.related.4.title': 'Tuition Details by Course',
  'courses.related.4.description': 'Full fee breakdown for each course',
  'courses.related.5.title': 'Curriculum',
  'courses.related.5.description': 'The full picture of what each course teaches',

  // comparisonRows: row labels
  'courses.row.duration': 'Duration',
  'courses.row.days': 'Total Days',
  'courses.row.hours': 'Total Hours',
  'courses.row.price': 'Tuition (tax incl.)',
  'courses.row.schedule': 'Intake',
  'courses.row.target': 'Designed For',
  'courses.row.goal': 'Learning Outcome',
  'courses.row.content': 'Main Topics',
  'courses.row.cert': 'Certification',
  'courses.row.transfer': 'Step-Up Discount',

  // comparisonRows: essential column values
  'courses.row.essential.duration': '1 month',
  'courses.row.essential.days': '8 days',
  'courses.row.essential.hours': '48 hours',
  'courses.row.essential.price': `JPY ${incYenOf('ac-essential')}`,
  'courses.row.essential.schedule': 'July & January',
  'courses.row.essential.target': 'Beginners & career changers',
  'courses.row.essential.goal': 'Master foundational deportment and service etiquette; capable of delivering everyday service independently',
  'courses.row.essential.content': 'Basic manners, household management, table setting, tea & coffee, garment care, communication',
  'courses.row.essential.cert': 'Certified Associate Butler',
  'courses.row.essential.transfer': '—',

  // comparisonRows: advanced column values
  'courses.row.advanced.duration': '2 months',
  'courses.row.advanced.days': '12 days',
  'courses.row.advanced.hours': '72 hours',
  'courses.row.advanced.price': `JPY ${incYenOf('ac-advanced')}`,
  'courses.row.advanced.schedule': 'May–June & Nov–Dec',
  'courses.row.advanced.target': 'Those with a foundation; seeking specialist skills (beginners may also enrol directly)',
  'courses.row.advanced.goal': 'Master the full content of Essential plus advanced service technique and wine knowledge; deliver seamless service to multiple guests simultaneously',
  'courses.row.advanced.content': 'Full content of Essential, plus advanced service, wine & spirits, event management, international etiquette, luxury garment care',
  'courses.row.advanced.cert': 'Certified Professional Butler',
  'courses.row.advanced.transfer': 'Essential graduate: −JPY 80,000',

  // comparisonRows: master column values
  'courses.row.master.duration': '3 months',
  'courses.row.master.days': '16 days',
  'courses.row.master.hours': '96 hours',
  'courses.row.master.price': `JPY ${incYenOf('ac-master')}`,
  'courses.row.master.schedule': 'Feb–Apr & Sep–Nov',
  'courses.row.master.target': 'Aspiring professionals & those pursuing management roles (beginners may also enrol directly)',
  'courses.row.master.goal': 'Master the full content of Essential and Advanced plus management, crisis response, and international protocol; lead a team as head butler',
  'courses.row.master.content': 'Full content of Essential and Advanced, plus household management, crisis & security, international protocol, VIP service, leadership',
  'courses.row.master.cert': 'Certified Master Butler',
  'courses.row.master.transfer': 'Advanced graduate: −JPY 180,000',
};

export default courses;
